// @ts-nocheck
import React, { useCallback, useEffect } from "react";
import {
  List,
  Datagrid,
  TopToolbar,
  sanitizeListRestProps,
  TextField,
  ReferenceInput,
  AutocompleteInput,
  Pagination,
  DateField,
  FilterButton,
  FunctionField,
  SelectInput,
  TextInput,
  Button,
  useListContext,
  Confirm,
  useCreate,
  useNotify,
} from "react-admin";
import { Box, Paper, Tab, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import GetAppIcon from "@mui/icons-material/GetApp";
import mbaas from "src/provider/Mbaas";
import { endOfToday, format } from "date-fns";
import { useDispatch } from "react-redux";
import { setSurfsharkFilter } from "src/slices/surfsharkPage/filterSurfsharkSlice";
import { DateRange } from "../DateRange";
import { TabContext, TabList } from "@mui/lab";
import { useState } from "react";
import { dataProvider } from "../../provider";

const ListActions = (props) => {
  const {
    className,
    exporter,
    filters,
    filter,
    SurfsharkFilter,
    maxResults,
    navigate,
    ...rest
  } = props;
  const [userData, setUserData] = React.useState({});
  const [open, setOpen] = React.useState(false);
  const notify = useNotify();

  const getUserData = async () => {
    const res = await mbaas.client.user.get();
    if (res.data) {
      setUserData(res.data);
    }
    if (res.error) {
      notify(res.error);
    }
  };

  React.useEffect(() => {
    getUserData();
  }, []);

  const { filterValues } = useListContext();

  // -- export button
  const ExportSurfsharkButton = () => {
    const type_name = "surfshark-purchase";
    const gen_file_name = `${type_name}_${format(new Date(), "yyyy-MM-dd_HH-mm-ss")}`;
    const [exportData, { isLoading }] = useCreate("reports", {
      data: {
        author_id: userData?.id,
        type: type_name,
        status: "queued",
        data: {
          filter: {
            ...filter,
            ...filterValues,
          },
          metadata: {
            generated_filename: gen_file_name,
          },
        },
      },
    });

    const handleOnClick = () => {
      exportData();
      setOpen(true);
    };

    const navigateToReportPage = () => {
      navigate(encodeURI(`/reports?filter={"type":"surfshark-purchase"}`));
    };
    const ConfirmDialogContent = () => {
      return (
        <Paper elevation={0}>
          <Typography variant="body1" gutterBottom>
            Your file is exported as "{gen_file_name}.csv", to view the progress
            please visit report page below
          </Typography>
        </Paper>
      );
    };

    return (
      <Button
        label="Export Surfshark Data"
        disabled={isLoading}
        onClick={() => handleOnClick()}
      >
        <GetAppIcon />
        <Confirm
          isOpen={open}
          title="Dear User,"
          content={<ConfirmDialogContent />}
          onClose={() => setOpen(false)}
          confirm="Go To Report"
          onConfirm={navigateToReportPage}
        />
      </Button>
    );
  };

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      <FilterButton filters={SurfsharkFilter} />
      <ExportSurfsharkButton />
    </TopToolbar>
  );
};

const SurfsharkPagination = () => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} />
);

const rowStyleByStatus = (record) => {
  const bgColorMap = {
    success: "#dcf8c6",
    failed: "#ffe4e4",
  };
  let bgColor = bgColorMap[record.status?.toLowerCase()];
  if (!bgColor) bgColor = "transparent";
  return {
    backgroundColor: bgColor,
  };
};

export const SurfsharkList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [dataStorage] = useState(() => {
    try {
      const saved = localStorage.getItem("tab_surfshark");
      return JSON.parse(saved) || "";
    } catch {
      return "";
    }
  });

  const [value, setValue] = React.useState(dataStorage.tab_surfshark || "m21");
  const [filter, setFilter] = React.useState({
    isGrapari: false,
    isMvno: false,
    itemKey: "SSHK1M",
  });

  const SurfsharkFilter = [
    <DateRange key="date_range" alwaysOn />,
    <TextInput
      key="order_id"
      source="order_id"
      label="Order ID"
      alwaysOn
      data-testid="search-order-id"
      onChange={(e) =>
        dispatch(setSurfsharkFilter({ order_id: e.target.value }))
      }
      sx={{ maxWidth: "150px" }}
    />,
    <TextInput
      key="purchase_id"
      source="purchase_id"
      label="Purchase ID"
      alwaysOn
      data-testid="search-purchase-id"
      onChange={(e) =>
        dispatch(setSurfsharkFilter({ purchase_id: e.target.value }))
      }
      sx={{ maxWidth: "150px" }}
    />,
    <SelectInput
      key="status"
      source="status"
      label="Status"
      choices={[
        { id: "PAID", name: "PAID" },
        { id: "PENDING", name: "PENDING" },
        { id: "SUCCESS", name: "SUCCESS" },
        { id: "FAILED", name: "FAILED" },
      ]}
      alwaysOn
      data-testid="search-status"
      onChange={(e) => dispatch(setSurfsharkFilter({ status: e.target.value }))}
      sx={{ maxWidth: "150px" }}
    />,
    <AutocompleteInput
      fullWidth
      size="small"
      source="user_country"
      key="user_country"
      label="Country"
      optionText={(choice) => choice.name}
      choices={[
        { id: "HK", name: "Hong Kong" },
        { id: "TW", name: "Taiwan" },
      ]}
      onChange={(e) => dispatch(setSurfsharkFilter({ user_country: e }))}
      alwaysOn
      sx={{ maxWidth: "150px" }}
    />,
    <ReferenceInput
      key={`product_catalog_id_${value}`}
      source="product_catalog_id"
      reference="productCatalogs"
      label="Product"
      filter={{ itemKey: "SSHK1M", isMvno: value === "mygrapari" }}
    >
      <AutocompleteInput
        key={`product_autocomplete_${value}`}
        fullWidth
        source="label"
        optionText={(choice) => `${choice.label} - ${choice.item_key}`}
        label="Product"
        onChange={(e) =>
          dispatch(setSurfsharkFilter({ product_catalog_id: e }))
        }
        sx={{ maxWidth: "150px" }}
      />
    </ReferenceInput>,
    <ReferenceInput
      key="user_id"
      source="user_id"
      reference="subscribers"
      label="Subscriber Name"
    >
      <AutocompleteInput
        fullWidth
        source="name"
        data-testid="search-subscriber"
        optionText={(choice) => choice.name}
        label="Type in a name"
        onChange={(e) => dispatch(setSurfsharkFilter({ user_id: e }))}
        sx={{ maxWidth: "150px" }}
      />
    </ReferenceInput>,
  ];

  React.useEffect(() => {
    if (value === "m21") {
      setFilter({ isGrapari: false, isMvno: false, itemKey: "SSHK1M" });
    } else if (value === "mygrapari") {
      setFilter({ isGrapari: true, isMvno: true, itemKey: "SSHK1M" });
    }
  }, [value]);

  const handleChange = (e: SyntheticEvent, newValue: string) => {
    e.preventDefault();
    localStorage.setItem(
      "tab_surfshark",
      JSON.stringify({ tab_surfshark: newValue }),
    );
    setValue(newValue);
    dispatch(setSurfsharkFilter({ product_catalog_id: "" }));
    // Clear product_catalog_id from react-admin's URL-persisted filter state
    const searchParams = new URLSearchParams(window.location.search);
    const filterParam = searchParams.get("filter");
    if (filterParam) {
      try {
        const filters = JSON.parse(filterParam);
        delete filters.product_catalog_id;
        searchParams.set("filter", JSON.stringify(filters));
        navigate({ search: searchParams.toString() }, { replace: true });
      } catch {}
    }
  };

  // Currency conversion
  const [currencyRates, setCurrencyRates] = useState({});

  const formatNumber = (number, currency) => {
    switch (currency) {
      case "IDR":
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(number);
      case "USD":
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        }).format(number);
      case "TWD":
        return new Intl.NumberFormat("zh-TW", {
          style: "decimal",
          minimumFractionDigits: 0,
        }).format(number);
      case "MYR":
        return new Intl.NumberFormat("ms-MY", {
          style: "currency",
          currency: "MYR",
          minimumFractionDigits: 2,
        }).format(number);
      case "HKD":
        return new Intl.NumberFormat("zh-HK", {
          style: "currency",
          currency: "HKD",
          minimumFractionDigits: 2,
        }).format(number);
      default:
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
        }).format(number);
    }
  };

  useEffect(() => {
    const currencies = ["IDR", "USD", "MYR", "HKD"];
    const fetchRates = async () => {
      const rates = {};
      for (const currency of currencies) {
        const response = await dataProvider.getList("currencyRates", {
          filter: { origin: currency, destination: "TWD" },
          pagination: { page: 1, perPage: 1 },
          sort: { field: "created_at", order: "DESC" },
        });
        const items = response.data || [];
        rates[currency] = items[0]?.rate || (currency === "HKD" ? 4 : 1);
      }
      setCurrencyRates(rates);
    };
    fetchRates();
  }, []);

  return (
    <>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="Surfshark tabs">
            <Tab label="M21" value="m21" />
            <Tab label="MyGrapari" value="mygrapari" />
          </TabList>
        </Box>
      </TabContext>
      <List
        key={value}
        resource="purchaseLogs"
        title="Consumptions › Surfshark"
        filter={filter}
        filters={SurfsharkFilter}
        actions={
          <ListActions
            navigate={navigate}
            surfsharkFilter={SurfsharkFilter}
            filter={filter}
          />
        }
        perPage={50}
        sort={{ field: "created_at", order: "DESC" }}
        pagination={<SurfsharkPagination />}
        sx={{
          flexGrow: 1,
          transition: (theme: any) =>
            theme.transitions.create(["all"], {
              duration: theme.transitions.duration.enteringScreen,
            }),
        }}
      >
        <Datagrid rowStyle={rowStyleByStatus} bulkActionButtons={false}>
          <DateField source="created_at" label="Date" showTime />
          <TextField source="order_id" label="Order ID" />
          <TextField source="purchase_id" label="Purchase ID" />
          <FunctionField
            label="Origin Cost"
            render={(record) => {
              const dataHistory = record?.histories;
              if (dataHistory !== null) {
                if (dataHistory.length) {
                  const history = record?.histories?.find(
                    (h) => h.status === "SUCCESS",
                  );
                  if (history) {
                    const originCost =
                      history.data?.orderDetail?.cost?.hkd_cost;
                    const originCurrency = "HKD";
                    if (originCost && originCurrency) {
                      const rate = currencyRates[originCurrency] || 1;
                      return `NTD ${formatNumber(originCost * rate, "TWD")}`;
                    }
                  }
                } else {
                  return "";
                }
              }
              return "";
            }}
            sortable={false}
          />
          <TextField
            source="user_id_data.phone"
            label="Register Number"
            sortable={false}
          />
          <TextField
            source="product_catalog_id_data.label"
            label="Product"
            sortable={false}
          />
          <TextField
            source="product_catalog_id_data.item_key"
            label="Item Key"
            sortable={false}
          />
          <TextField
            source="product_catalog_id_data.item_group"
            label="Item Group"
            sortable={false}
          />
          <TextField source="selling_price" label="Selling Price" />
          <FunctionField
            label="Status"
            source="status"
            render={(record) => <label>{record.status?.toUpperCase()}</label>}
          />
          <FunctionField
            label="Auto Renewal"
            render={(record) =>
              record.surfshark_auto_renewal === true ? "YES" : "NO"
            }
            sortable={false}
          />
          <FunctionField
            label="Remark"
            source="remark"
            render={(record) => <label>{record.remark}</label>}
          />
        </Datagrid>
      </List>
    </>
  );
};
